import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { EVENTS } from '../../CONSTANTS/tpi-common-constants';

@Directive({
    selector: '[tpiToUppercaseDirective]'

})
export class ToUppercaseDirective {
    element = inject(ElementRef);
    private ngControl = inject(NgControl);

    @HostListener(EVENTS.INPUT)
    onInput(): void {
        const uppercaseInput = this.element.nativeElement.value.toUpperCase();
        this.element.nativeElement.value = uppercaseInput;
        this.ngControl.control.setValue(uppercaseInput);
    }
}